var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-icon',{style:(_vm.style),attrs:{"x-large":"","color":"black"}},[_vm._v(" "+_vm._s(_vm.icon)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }